// extracted by mini-css-extract-plugin
export var cardIcon = "_bb-4";
export var checkboxCard = "_bb-0";
export var checkboxCardSelected = "_bb-3";
export var disabled = "_bb-1";
export var outerBorder = "_bb-2";
export var spacerMedium = "_bb-7";
export var spacerSmall = "_bb-6";
export var spacerXsmall = "_bb-5";